import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { AppDataContext } from '~/contexts/AppDataContext';
import { ArticleContext } from '~/contexts/ArticleContext';
import { getCSSColorText } from '~/utilities/getCSS';

const wrapClasses = cva('my-4 mx-0 flex items-center', {
  variants: {
    sideBySide: {
      true: 'justify-center gap-2',
      false: 'text-center flex-col',
    },
  },
});

const cssClasses = cva('font-group-big', {
  variants: {
    color: getCSSColorText(),
    sideBySide: {
      false: 'mb-2',
    },
  },
});

const cssImageClasses = cva('', {
  variants: {
    sideBySide: {
      true: 'h-6',
      false: 'h-10',
    },
  },
});

type Sponsor = {
  brandName: string;
  image: string;
  text: string;
  url: string;
};

type ArticleSponsorType = {
  sideBySide?: boolean;
};

export default component$(
  ({ sideBySide = false }: ArticleSponsorType): JSX.Element => {
    const {
      themeComponents: { articleBlock },
    } = useContext(AppDataContext);
    const article = useContext(ArticleContext);

    if (!article || !article.metadata) return <></>;

    const { sponsor = {} } = article.metadata;

    if (!Object.keys(sponsor).length) return <></>;

    const { text, image, brandName, url } = sponsor as Sponsor;

    return (
      <div class={wrapClasses({ sideBySide })}>
        <h4
          class={cssClasses({
            sideBySide,
            color: articleBlock.sponsorTextColor.value,
          })}
        >
          {text}
        </h4>
        <a href={url} rel='nofollow sponsored' target='_blank'>
          {image && (
            <img
              class={cssImageClasses({
                sideBySide,
              })}
              src={`data:image/svg+xml,${encodeURIComponent(image)}`}
              alt={brandName}
              height={undefined}
              width={undefined}
            />
          )}
        </a>
      </div>
    );
  }
);
